import { useSelector } from 'react-redux';
import classNames from 'classnames';

import styles from './ErknmStatusHint.module.scss';
import { IconExclamationCircle } from '../../../UIPackage/IconsModule/components/IconExclamationCircle';
import { scrollToBlock } from '../../../CorePackage/MainModule/common/scrollToBlock';
import {
  getDecisionErrorFields,
  getDecisionStatusHintFields,
  getDecisionStatusHintText,
} from '../../../DecisionPackage/MainModule/selectors/decisionSelectors';

interface IDecisionStatusHintProps {
  isHover?: boolean;
}

export const DecisionStatusHint = ({ isHover }: IDecisionStatusHintProps) => {
  const errorFields = useSelector(getDecisionErrorFields);
  const hintText = useSelector(getDecisionStatusHintText);
  const hintFields = useSelector(getDecisionStatusHintFields);

  if (errorFields?.length || (!hintText && !hintFields?.length)) {
    return null;
  }

  return (
    <div className={classNames(styles.StatusHint, { [styles.StatusHintHover]: isHover })}>
      <IconExclamationCircle className={styles.Icon} />
      <div className={styles.Content}>
        <div className={hintFields?.length ? styles.BorderBottom : ''}>{hintText}</div>
        {!!hintFields?.length && (
          <ul className={styles.List}>
            {hintFields.map((item, index) => (
              <li key={index}>
                <div onClick={() => scrollToBlock(item.scrollToId)}>{item.title}</div>
              </li>
            ))}
          </ul>
        )}
      </div>
    </div>
  );
};
